<template>
  <div class="communication-component">
    <div class="main-title">
      <span>{{ title }}</span
      ><span v-if="isMobile" class="float-right">{{
        this.$genericClass.formatDate(uploadDate, true)
      }}</span>
    </div>
    <div class="description">{{ description }}</div>
    <div class="buttons-div">
      <v-btn
        class="generic-button first"
        @click="back"
        :disabled="isPreview"
        v-if="isPreview"
        >{{ $t("Misc.back") }}</v-btn
      ><v-btn
        class="generic-button"
        @click="downloadAndAccept"
        :disabled="isPreview || commBtnClicked"
        >{{ $t("Communications.downloadAndAccept") }}</v-btn
      >
    </div>
  </div>
</template>
<style>
.communication-component {
  font: normal normal normal 20px Lato;
  padding: 27px 138px 27px 138px;
}

.communication-component .main-title {
  /* text-decoration: underline; */
  padding-bottom: 32px;
  font: normal normal bold 30px/35px Roboto;
  color: #6f767a;
}

.communication-component .description {
  font: normal normal normal 20px/24px Helvetica Neue;
}

.communication-component .buttons-div {
  position: relative;
  width: 100%;
}

.communication-component .generic-button.first {
  position: absolute;
  left: 0;
}
@media (max-width: 600px) {
  .communication-component {
    padding: 27px 31px 27px 31px;
  }

  .communication-component .description {
    font: normal normal normal 14px Roboto;
  }

  .communication-component .main-title {
    font: normal normal bold 14px Lato;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
import MyFercamApi from "../api/MyFercam/MyFercamApi.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import HSApi from "../api/Hyperstorage/HSApi.js";

export default {
  props: {
    title: "",
    description: "",
    uploadDate: "",
    isPreview: false,
    communicationId: null,
  },
  data() {
    return {
      isMobile: false,
      commBtnClicked: false,
    };
  },

  created() {
    this.setIsMobile();
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
    async downloadAndAccept() {
      this.commBtnClicked=true;
            
      var res = await MyFercamApi.GetCommunication(this.communicationId);
      //   console.log("GetCommunication", res.data);
      await this.downloadAttachments(res.data);

      MyFercamApi.ReadCommunication(
        this.communicationId,
        this.$GAUserAuth.user.username
      ).then((res) => {
        this.commBtnClicked=false;
        // update mail icon notifications
        this.$store.commit(
          "SET_communicationsUpdated",
          !this.$store.getters.GET_communicationsUpdated
        );
      })
      .catch((error) => {
          this.commBtnClicked=false;
        });
    },
    back() {},
    async downloadAttachments(communications) {
      if (communications.length == 1) {
        let pdf = await HSApi.Download(communications[0].fileGuid);
        // console.log("download", pdf.data);
        saveAs(
          new Blob([pdf.data], { type: "application/pdf" }),
          communications[0].filename
        );
      } else if (communications.length > 1) {
        let zip = await HSApi.DownloadZip(
          communications.map((a) => a.fileGuid)
        );
        // console.log("download", zip.data);
        saveAs(
          new Blob([zip.data], { type: "application/octet-stream" }),
          "package.zip"
        );
      }
    },
  },
};
</script>